/** Generator Status Review labels and defaults shared by the UI, SQL read path, and CSV. */

/** Hide short periods below reported status unless direction or consecutive months is explicitly filtered. */
export const DOWNWARD_MIN_SUSTAINED_MONTHS = 12;

/** Risk uses the span between affected months, including gaps, not elapsed time awaiting review. */
export const RISK_ELEVATED_MIN_RUN_MONTHS = 3;
export const RISK_HIGH_MIN_RUN_MONTHS = 6;

/** Stable filter/URL keys; display text is in EXCEEDANCE_STAGE_LABELS. */
export const EXCEEDANCE_STAGE_IDS = [
  "AWAITING_VALIDATION",
  "READY_FOR_PICKUP",
  "IN_FLIGHT",
  "AWAITING_CORRECTION",
  "RESOLVED",
  "IGNORED",
] as const;

export type ExceedanceStage = (typeof EXCEEDANCE_STAGE_IDS)[number];

/** Review status labels shared by cards, filters, sorting, chips, and exports. */
export const EXCEEDANCE_STAGE_LABELS: Record<ExceedanceStage, string> = {
  AWAITING_VALIDATION: "Needs validation",
  READY_FOR_PICKUP: "Ready for pickup",
  IN_FLIGHT: "Submission in progress",
  AWAITING_CORRECTION: "Awaiting manifest correction",
  RESOLVED: "Resolved",
  IGNORED: "Dismissed",
};

/** Same-month calculated versus reported comparisons, independent of validation. */
export const EXCEEDANCE_DIRECTION_LABELS: Record<"UPWARD" | "DOWNWARD", string> = {
  UPWARD: "Above reported status",
  DOWNWARD: "Below reported status",
};

/** Display labels for the derived compliance-risk signal. */
export const EXCEEDANCE_RISK_LABELS: Record<"ELEVATED" | "HIGH", string> = {
  ELEVATED: "Elevated",
  HIGH: "High",
};

/** Resolution-method labels; a linked submission may still be in progress. */
export const EXCEEDANCE_RESOLUTION_TYPE_LABELS: Record<
  "NOTIFICATION_FILED" | "ACKNOWLEDGED" | "DISMISSED" | "MANIFEST_CORRECTION",
  string
> = {
  NOTIFICATION_FILED: "Linked submission",
  ACKNOWLEDGED: "Corrected elsewhere",
  DISMISSED: "Dismissed",
  MANIFEST_CORRECTION: "Manifest correction",
};
